import { Box, Button, Flex, Heading, Image, Spacer } from "@chakra-ui/react";
import useLogout from "../../../../../utils/hooks/useLogout";
import { useNavigate } from "react-router";
import logo from "../../../../../assets/logo_no_name.png";
import React from "react";

export default function DashboardHeader() {
  const { logout } = useLogout();
  const navigate = useNavigate();

  return (
    <Box as="nav" bg="talesSecondary.500">
      <Flex p="10px" alignItems="center" className="navbar" maxW="7xl" m="auto">
        <Image
          src={logo}
          mr={{ base: "15px", sm: "24px", md: "30px" }}
          w={{ base: "50px", sm: "60px", md: "70px" }}
          h={{ base: "50px", sm: "60px", md: "70px" }}
        />
        <Heading color="talesWhite" size="lg">
          TALES DASHBOARD ADMIN
        </Heading>
        <Spacer />
        <Button marginRight="20px" onClick={() => navigate("/")}>
          VAI AL SITO
        </Button>
        <Button onClick={() => logout()}>LOGOUT</Button>
      </Flex>
    </Box>
  );
}
